import { scaleBand, scaleLinear } from 'd3-scale';
import noop from 'lodash/noop';
import { createContext } from 'react';

import { WIDTH, WRAPPER } from './constants';

import type { Context } from './types';

export const context = createContext<Context>({
  data: [],
  wrapperWidth: WRAPPER.width,
  width: WIDTH,
  xScale: scaleBand(),
  yScale: scaleLinear(),
  yLabels: [],
  TooltipContent: () => null,
  onInteract: noop,
  gradeType: 'Cumulative',
});

export const { Provider } = context;
